// extracted by css-extract-rspack-plugin
export default {"cls1":"UserSentimentPopup-cls1_xpo","cls2":"UserSentimentPopup-cls2_1wD UserSentimentPopup-cls1_xpo"};